import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
import { ModalHeader } from 'reactstrap';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import AnpassadRBody from './AnpassadRBody'
import SparaRapportChips from './SparaRapportChips'
import GetChipsFromSaved from './GetChipsFromSaved'
import {isEmpty} from 'lodash'
import {
    getAnpassadRapport,getKontoUtokning,getSparadAnRapport
} from 'actions'
import {Button} from '@material-ui/core'
import IntlMessages from 'util/IntlMessages';
const styles = (theme) => ({
    root: {
        padding: theme.spacing(2),
        margin: theme.spacing(4),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});
const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});
const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);


function mapStateToProps({auth,accountsData}) {
    const { Flags,OrderStatusList,SavedAnRapport } = accountsData;
    const { authUser } = auth;
    return {
        authUser,Flags,OrderStatusList,SavedAnRapport
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getAnpassadRapport:(Afid,userid,Mstate,saved,Email,name)=>dispatch(getAnpassadRapport(Afid,userid,Mstate,saved,Email,name)),        
        getKontoUtokning:(Afid,userid)=>dispatch(getKontoUtokning(Afid,userid)),
        getSparadAnRapport:(Afid,userid)=>dispatch(getSparadAnRapport(Afid,userid)),
    };
}

class index extends Component {
    state={
        OpenSavedPopUp:false,
        selectedSVRapport:"",
        Email:"",
        Namn:"",
        Mstate:[
            {Meta:"Kund namn",Value:0,Checked:true},
            {Meta:"Kund orgnr",Value:0,Checked:true},
            {Meta:"Kundnr",Value:0,Checked:true},
            {Meta:"Ansvarig",Value:-1,Checked:true},
            {Meta:"Adress",Value:0,Checked:false},
            {Meta:"Extra adress",Value:0,Checked:false},
            {Meta:"Telefon",Value:0,Checked:false},
            {Meta:"Extra telefon",Value:0,Checked:false},
            {Meta:"Kundtyp",Value:-1,Checked:false},
            {Meta:"Kund epost",Value:-1,Checked:false},
            {Meta:"Taggning",Value:-1,Checked:false},
            {Meta:"Distrikt",Value:-1,Checked:false},
            {Meta:"Fria fält",Value:-1,Checked:false},
            
            {Meta:"Kontaktperson namn",Value:0,Checked:false},
            {Meta:"Kontaktperson e-post",Value:0,Checked:false},
            {Meta:"Kontaktperson tele",Value:0,Checked:false},
            {Meta:"Kontaktperson roll",Value:0,Checked:false},
            {Meta:"Kontaktperson personnr",Value:0,Checked:false},
            {Meta:"Firmatecknare",Value:-1,Checked:false},
            {Meta:"Avtal/Prospekt",Value:-1,Checked:false},
            {Meta:"Typ",Value:-1,Checked:false},
            {Meta:"Ägare",Value:-1,Checked:false},
            {Meta:"Rubrik",Value:0,Checked:false},
            {Meta:"Värde",Value:0,Checked:false},
            {Meta:"Avtal fakturastatus",Value:0,Checked:false},
            {Meta:"Avtal TB",Value:0,Checked:false},
            {Meta:"Avtal Inpris",Value:0,Checked:false},
            {Meta:"Avtal Utpris",Value:0,Checked:false},
            {Meta:"Id",Value:0,Checked:false},
            {Meta:"Avtal status",Value:-1,Checked:false},
            {Meta:"Prospekt status",Value:-1,Checked:false},
            {Meta:"Prospekt fas",Value:-1,Checked:false},
            {Meta:"Leverantör",Value:-1,Checked:false},
            {Meta:"Avtal skapa datum",Value:0,Checked:false},
            {Meta:"Avtal skapa datum F.O.M",Value:0,Checked:false},
            {Meta:"Avtal skapa datum T.O.M",Value:0,Checked:false},
            {Meta:"Avtal start datum",Value:0,Checked:false},
            {Meta:"Avtal start datum F.O.M",Value:0,Checked:false},
            {Meta:"Avtal start datum T.O.M",Value:0,Checked:false},
            {Meta:"Avtal omförhandling datum",Value:0,Checked:false},
            {Meta:"Avtal omförhandling datum F.O.M",Value:0,Checked:false},
            {Meta:"Avtal omförhandling datum T.O.M",Value:0,Checked:false},
            {Meta:"Avtal löper ut datum",Value:0,Checked:false},
            {Meta:"Avtal löper ut datum F.O.M",Value:0,Checked:false},
            {Meta:"Avtal löper ut datum T.O.M",Value:0,Checked:false},
            {Meta:"Prospekt deadline datum",Value:0,Checked:false},
            {Meta:"Prospekt deadline datum F.O.M",Value:0,Checked:false},
            {Meta:"Prospekt deadline datum T.O.M",Value:0,Checked:false},
            {Meta:"OrderId",Value:0,Checked:false},
            {Meta:"Ordertyp",Value:-1,Checked:false},
            {Meta:"Order leverantör",Value:-1,Checked:false},
            {Meta:"Order status",Value:-1,Checked:false},
            {Meta:"Order antal",Value:0,Checked:false},
            {Meta:"Order antal ny",Value:0,Checked:false},
            {Meta:"Order antal förlängnig",Value:0,Checked:false},
            {Meta:"Order affär från",Value:0,Checked:false},
            {Meta:"Order värde totalt",Value:0,Checked:false},
            {Meta:"Order värde TB",Value:0,Checked:false},
            {Meta:"Order värde TB intäkt",Value:0,Checked:false},
            {Meta:"Order värde TB kostnad",Value:0,Checked:false},
            {Meta:"Order löpande",Value:0,Checked:false},
            {Meta:"Order löpande intäkt",Value:0,Checked:false},
            {Meta:"Order löpande kostnad",Value:0,Checked:false},
            {Meta:"Order värde Inpris",Value:0,Checked:false},
            {Meta:"Order värde Utpris",Value:0,Checked:false},
            {Meta:"Order Etiketter",Value:0,Checked:false},
            {Meta:"Order ägare",Value:-1,Checked:false},
            {Meta:"Order skapad datum",Value:0,Checked:false},
            {Meta:"Order skapad datum F.O.M",Value:0,Checked:false},
            {Meta:"Order skapad datum T.O.M",Value:0,Checked:false},
            {Meta:"Order registrering datum",Value:0,Checked:false},
            {Meta:"Order registrering datum F.O.M",Value:0,Checked:false},
            {Meta:"Order registrering datum T.O.M",Value:0,Checked:false},
            
            {Meta:"Order registrering datum",Value:0,Checked:false},
            {Meta:"Order registrering datum F.O.M",Value:0,Checked:false},
            {Meta:"Order registrering datum T.O.M",Value:0,Checked:false},

            {Meta:"Faktura datum",Value:0,Checked:false},
            {Meta:"Faktura datum F.O.M",Value:0,Checked:false},
            {Meta:"Faktura datum T.O.M",Value:0,Checked:false},

            {Meta:"Betalatdatum",Value:0,Checked:false},
            {Meta:"Betalatdatum F.O.M",Value:0,Checked:false},
            {Meta:"Betalatdatum T.O.M",Value:0,Checked:false},

        ]
    }
    onChangeMstate=(Nstate)=>{

        this.setState({
            Mstate: Nstate,
            selectedSVRapport:""
        })
    }
    RapportBythis=()=>{
        const Afid = this.props.authUser.user_Afid;
        const MainUser = this.props.authUser.user_id;
        this.props.getAnpassadRapport(Afid,MainUser,this.state.Mstate,0,this.state.Email,this.state.Namn)  
        this.props.CloseAnpassadRapportPopUp()  
    }
    componentDidMount=()=>{
        const Afid = this.props.authUser.user_Afid;
        const userid = this.props.authUser.user_id;
        this.props.getKontoUtokning(Afid,userid)
        this.props.getSparadAnRapport(Afid,userid)
    }
    onCloseThis=()=>{
        this.setState({
            OpenSavedPopUp:false
        })
    }
    AskForSaving=()=>{
        this.setState({
            OpenSavedPopUp:true
        })
    }
    onSetThisEmail=(Email)=>{
        this.setState({
            Email:Email
        })        
    }
    onSetThisName=(Namn)=>{
        this.setState({
            Namn:Namn
        })        
    }
    onSaveThis=()=>{
        const Afid = this.props.authUser.user_Afid;
        const MainUser = this.props.authUser.user_id;
        this.props.getAnpassadRapport(Afid,MainUser,this.state.Mstate,1,this.state.Email,this.state.Namn)   
        this.props.CloseAnpassadRapportPopUp()         
    }
    onSelectSVRapport=(selected)=>{
        let Mstate= this.state.Mstate
        for(let item of JSON.parse(selected.JsonText)){
            if(Mstate.findIndex(ittem=>ittem.Meta === item.Meta) !== -1){
                Mstate[Mstate.findIndex(ittem=>ittem.Meta === item.Meta)] = item
            }
        }
        this.setState({
            selectedSVRapport:selected.JsonText,
            Email:selected.ToEmail,
            Namn:selected.RapportName,
            Mstate:Mstate
        })
    }
    render() {
        return (
            <>
            <Dialog open={this.props.OpenAnpassadRapport} 
              onClose={this.props.CloseAnpassadRapportPopUp} 
              aria-labelledby="customized-dialog-title" 
              fullWidth={true} 
              disableBackdropClick={true}
                disableEscapeKeyDown={true}
              maxWidth={"lg"}>
                    <ModalHeader className="modal-box-header bg-primary text-white">
                    Anpassad
                    <IconButton className="text-white"
                        onClick={this.props.CloseAnpassadRapportPopUp}>
                        <CloseIcon />
                    </IconButton>
                </ModalHeader>
                <DialogContent dividers className="p-0">
                    <AnpassadRBody
                    Mstate={this.state.Mstate}
                    OrderStatusList={this.props.OrderStatusList}
                    onChangeMstate={this.onChangeMstate}
                    />
                </DialogContent>
                {
                    !isEmpty(this.props.SavedAnRapport)?
                    <DialogContent dividers className="p-0">
                        <GetChipsFromSaved
                        SavedAnRapport={this.props.SavedAnRapport}
                        selectedSVRapport={this.state.selectedSVRapport}
                        onSelectSVRapport={this.onSelectSVRapport}
                        />
                    </DialogContent>
                    :""
                }
                <DialogActions>
                <div className="d-flex my-2 mx-2">
                <div className="ml-auto">
                <Button
                variant="contained"
                color="primary"
                className="jr-btn"
                //onClick={this.RapportBythis}
                onClick={this.AskForSaving}
                ><IntlMessages id="Report.Create"/>
                </Button>
                </div>
                </div>
                </DialogActions>
                {
                    
                    this.state.OpenSavedPopUp === true?
                    <SparaRapportChips
                    onSaveThis={this.onSaveThis}
                    onNotSaveThis={this.RapportBythis}
                    onCloseThis={this.onCloseThis}
                    selectedSVRapport={this.state.selectedSVRapport}
                    Email={this.state.Email}
                    onSetThisEmail={this.onSetThisEmail}
                    Name={this.state.Namn}
                    onSetThisName={this.onSetThisName}
                    />
                    :""
                }
            </Dialog>   
            </>
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(index);